import { trackPaddingSize, knobDiameter } from './constants.js';

const calculateKnobPosition = ({ pointIndex , containerWidth , points  })=>{
    const sizeOfPointArea = (containerWidth - 2 * trackPaddingSize) / points.length;
    // x position refers to left edge of draggable object (knob)
    // add trackPaddingSize to get left edge aligned with left edge of point area
    // add pointIndex times point area size to align left edge with left edge of correct index point area
    // add another half point area to get left edge aligned with center of point area
    // subtract half the knob diameter to center knob on center of point area
    const position = trackPaddingSize + pointIndex * sizeOfPointArea + sizeOfPointArea / 2 - knobDiameter / 2;
    return {
        x: position,
        y: 0
    };
};
const getCurrentPointIndex = ({ currentX , containerLeftEdge , containerWidth , points  })=>{
    const sizeOfPointArea = containerWidth / points.length;
    let calculatedPointIndex = 0;
    calculatedPointIndex = points.findIndex((point)=>{
        return currentX < points.indexOf(point) * sizeOfPointArea + sizeOfPointArea + containerLeftEdge;
    });
    return currentX >= containerLeftEdge + containerWidth ? points.length - 1 : calculatedPointIndex;
};

export { calculateKnobPosition, getCurrentPointIndex };
